import { render, staticRenderFns } from "./examType.vue?vue&type=template&id=572d4ed2&scoped=true&"
import script from "./examType.vue?vue&type=script&lang=js&"
export * from "./examType.vue?vue&type=script&lang=js&"
import style0 from "./examType.vue?vue&type=style&index=0&id=572d4ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d4ed2",
  null
  
)

export default component.exports